import { TicketSystem } from '../../api/generatedTypes/graphql';

export const externalTicketSystems = [
  TicketSystem.Ticketmaster,
  TicketSystem.Lippupiste,
  TicketSystem.Tixly,
];
